module.exports = __webpack_public_path__ + "img/c3.45e5d815.png";